import {cn} from '~/utils';
import {Scramble} from '~/components/scramble';
import type {Theme} from '@prisma/client';

type ThemeProps = {
  theme?: Theme;
};

const Component = ({
  children,
  className,
  id,
}: {
  children: string;
  className?: string;
  id?: number;
}) => {
  return (
    <div
      className={cn(
        'text-6xl font-title text-primary',
        className,
        getSpecialThemeClassName(id)
      )}
    >
      <Scramble>{children}</Scramble>
    </div>
  );
};

export const getSpecialThemeClassName = (id?: number) => {
  switch (id) {
    case 38:
      return 'text-green-500';
    default:
      return '';
  }
};

export const MainTheme = ({theme}: ThemeProps) => {
  if (!theme) return '?????';
  const render = () => {
    switch (theme.id) {
      case 1751:
        return (
          <Component className="text-3xl">{theme.name as string}</Component>
        );
      case 1659:
        return (
          <div>
            <Component>{theme.name as string}</Component>
            <p className="text-sm uppercase text-primary">
              Your game must <u>start</u> and <u>end</u> with a tie.
            </p>
          </div>
        );
      default:
        return <Component id={theme.id}>{theme.name as string}</Component>;
    }
  };

  return (
    <div className="mb-2 border-b border-primary pb-2">
      {render()}
      {theme.description && (
        <p className="text-sm uppercase text-primary">{theme.description}</p>
      )}
    </div>
  );
};
